import { Button, Stack, useTheme } from "@mui/material";
import { useState } from "react";
import axios from "axios";

export default function ParaBotonDescarga({
  rutaArchivo,
  nombreDescarga = "archivo.pdf",
  textoBoton = "Descargar archivo",
  textoDescargando = "Descargando...",
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const theme = useTheme();

  const descargarArchivo = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(rutaArchivo, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreDescarga);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error("Error al descargar el archivo:", err);
      setError(`Error al descargar el archivo: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack spacing={2} direction="row">
      <Button
        variant="contained"
        sx={{
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.secondary.main,
          "&:hover": {
            backgroundColor: theme.palette.error.main,
          },
        }}
        onClick={descargarArchivo}
        disabled={isLoading}
      >
        {isLoading ? textoDescargando : textoBoton}
      </Button>
      {error && <div>{error}</div>}
    </Stack>
  );
}
